import { Form, Formik } from "formik";
import React, { useContext, useRef } from "react";
import { FormContext } from "../../../App";
import * as yup from "yup";
import {
  Container,
  Paper
} from "@mui/material";

import { styled } from "@mui/system";
import DataLayerService from "utility/dataLayerService";
import Validation from "utility/validation";
import TermAndCondition from "components/atoms/TermAndCondition";
import EmailInput from "components/atoms/EmailInput";
import { LeafButton } from "components/atoms/LeafButtons";
import { useComponentName, useProduct } from "hooks";
import { scrollToTop, modalScrollToTop } from '../../../utility/functions';

const EmailAddress = (props) => {
  const location = props.dataSet?.location ? props.dataSet.location : "multi-step-modal-form";
  const form = props.dataSet?.form ? props.dataSet.form : "modal";
  const { activeStepIndex, setActiveStepIndex, formData, setFormData } = useContext(FormContext);
  const userJourneyTracking = props.dataSet?.tracking || '';
  const componentName = props.component || 'ZipChecker';
  const product = useProduct();
  const formName = useComponentName(componentName);
  const subformName = useComponentName(props.modalComponent);
  const formRef = useRef(null);
  const formHeader = props.dataSet?.formheader ? props.dataSet.formheader : "Get a FREE Estimate for a LeafFilter Gutter Guard System";
  let emailAddress = '';
  const homelevel = props.dataSet?.homelevel ? props.dataSet.homelevel : '';
  const rentown = props.dataSet?.rentown ? props.dataSet.rentown : '';
  const requestedcompletion = props.dataSet?.requestedcompletion ? props.dataSet.requestedcompletion : '';

  const ValidationSchema = yup.object().shape({
    emailAddress: yup
      .string()
      .matches(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i, 'Email Address is not valid.')
      .required("Email Address is required."),
  });

  const buttonSubmit = (e) => {
    const EmailValidation = Validation.EmailDataLayerValidation(emailAddress);

    // Validation Error.
    const validationError = {
      ...EmailValidation
    };

    if (Object.keys(validationError).length !== 0) {
      DataLayerService.formFailEvent(form, location, validationError);

      modalScrollToTop(props.modalComponent);
    }

    // Scroll to the Top.
    scrollToTop(formRef);
  }

  const prevStep = () => {
    setActiveStepIndex(activeStepIndex - 1);
  };

  const handleOnBlur = (event) => {
    switch (event.target.name) {
      case 'emailAddress':
        emailAddress = event.target.value;
        break;

      default:
        break;
    }

    // Passing lf.form.interaction event to DataLayer.
    DataLayerService.formInteractionEvent(form, location);
  };

  const StyledFormContainer = styled(Paper)(({ theme }) => ({
    background: "#ffffff",
    padding: `${theme.spacing(2)}`,
    borderRadius: 8,
    width: "100%",
    height: "auto",
  }));

  return (
    <Formik
      initialValues={{
        emailAddress: formData.emailAddress || '',
      }}
      validationSchema={ValidationSchema}
      onSubmit={(values) => {
        const { emailAddress } = values;

        const data = {
          ...formData,
          emailAddress: emailAddress,
        };
        setFormData(data);
        setActiveStepIndex(activeStepIndex + 1);

        // Scroll to the Top.
        scrollToTop(formRef);

        if (userJourneyTracking) {
          let stepNumber = 4;
          if (componentName === 'ModalForm') {
            stepNumber += 1;
          }

          if (homelevel) {
            stepNumber += 1;
          }
          if (rentown) {
            stepNumber += 1;
          }
          if (requestedcompletion) {
            stepNumber += 1;
          }

          // Passing lf.form.status event to DataLayer.
          DataLayerService.formStatusEvent(formName, subformName, product, stepNumber, 3, 'notcompleted');
        }

        // Passing lf.form.start event to DataLayer.
        DataLayerService.formStartEvent(form, location, data);
      }}
    >
      {({ handleSubmit, isSubmitting, errors }) => (
        <Container maxWidth={"sm"} disableGutters={true}>
          <StyledFormContainer>
            <Form
              onSubmit={handleSubmit}
              ref={formRef}
              onBlur={
                (event) => { handleOnBlur(event) }
              }
            >
              {isSubmitting && Object.keys(errors).length > 0 && scrollToTop(formRef)}
              <h3 className="fw-semibold c--dark-charcoal"> { formHeader } </h3>

              <EmailInput fieldName={'emailAddress'} />

              <LeafButton
                buttonType={"primary"}
                type="submit"
                handleClick={() => buttonSubmit()}
                isSubmitting={isSubmitting}
                style={{
                  width: "100%"
                }}
              >
                Next
              </LeafButton>

              <div className="back-button">
                <LeafButton buttonType={"secondary"} onClick={prevStep}>
                  Back
                </LeafButton>
              </div>
              <TermAndCondition />
            </Form>
          </StyledFormContainer>
        </Container>
      )}
    </Formik>
  );
}

export default EmailAddress;
